export const links = {
  userActivities: '/admin/user-activities',
  logIn: '/login',
  refresh: '/refresh',
  jwks: '/jwks',
  logout: '/logout',
  me: '/me',
  notifications: '/notifications',
  users: '/users',
  candidateActions: '/candidate-actions',
  feedback: '/feedback',
};
